import { RenderOnScreen } from '@/components/atoms/RenderOnScreen'
import { useSocialUserContext } from '@/entity/chat/useSocialUserContext'
import List from '@mui/material/List'
import { ChatListRow } from './ChatListRow'

export const ChatListContainer = ({
  showChat
}: {
  showChat: (id: string) => any
}) => {
  const { activeChats, alerts: notifications } = useSocialUserContext()

  const sorted = [...(activeChats || [])].reverse()

  return (
    <List dense disablePadding>
      {sorted?.map(room => {
        return (
          <RenderOnScreen key={room} height={64}>
            <ChatListRow
              id={room}
              showChat={showChat}
              alert={notifications?.[room]}
            />
          </RenderOnScreen>
        )
      })}
    </List>
  )
}
